import React, { useState } from "react";

import { Col, Collapse, Input, Row } from "antd";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import "./reports.css";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { SearchOutlined, StarOutlined, StarFilled } from "@ant-design/icons";

import { reportsList } from "./reportData";
const { Panel } = Collapse;

const ReportsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "Bulk Property Reports",
      "1",
      "",
      "",
      "/reporting/reports/bulk-property-reports"
    ),
    RightBarMethod(
      "Bulk Update Owner Packet Settings",
      "2",
      "",
      "",
      "/reporting/bulk-update-owner-packet-settinsg"
    ),
  ]),

  RightBarMethod(" STATEMENTS", "t2", <i className="fa-solid fa-file"></i>, [
    RightBarMethod(
      "Send Owner Packets",
      "3",
      "",
      "",
      "/communication/letters_templates/send_owner_packets"
    ),
    RightBarMethod("Send Statements", "4", "", "", ""),
    RightBarMethod("Bulk Update Statement Settings", "5", "", "", ""),
  ]),

  RightBarMethod(" LETTERS", "t3", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("3-Day Notices", "6", "", "", "/"),
    RightBarMethod("Tenant Unpaid Charges", "7", "", "", "/"),
    RightBarMethod(
      "Owner Portal Announcement",
      "8",
      "",
      "",
      "/communication/letters_templates/owner-portal-announcement"
    ),
    RightBarMethod("Owner Portal Activation", "9", "", "", "/"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("SayEagle Reports Glossary", "13", "", "", "/")]
  ),
];

function Reports() {
  const [allReports, setAllReports] = useState(reportsList);

  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

  const handleFavorite = (key) => {
    setAllReports(
      [...allReports].map((object) => {
        return {
          ...object,

          children: object.children.map((k) => {
            if (k.key === key) {
              if (k.favorite) {
                return {
                  ...k,
                  favorite: false,
                };
              } else
                return {
                  ...k,
                  favorite: true,
                };
            }
            return k;
          }),
        };
      })
    );
  };

  const fvrtList = [];
  allReports.map((item) => {
    item.children.map((k) => {
      if (k.favorite) {
        return fvrtList.push({
          key: k.key,
          header: k.header,
          description: k.description,
          favorite: k.favorite,
        });
      }
    });
  });

  return (
    <>
      <div className="ReportsPage">
        <div className="pageheading">
          <h1>Reports</h1>
          <div className="filterNbtn">
            <button className="reportBuilderBtn">Report Builder</button>
          </div>
        </div>
        <Input
          suffix={<SearchOutlined />}
          placeholder="Search reports by name, description, or column"
        />
        <br />
        <br />
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? <RiArrowUpSLine /> : <RiArrowDownSLine />
          }
          className="reportsPageCollapse"
        >
          <Panel header="Favorite Reports" key="fvrt">
            <Row gutter={[24, 16]} style={{ rowGap: "0" }}>
              {/* {fvrtList.map((fvrt, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Collapse
                        expandIcon={({ isActive }) =>
                          isActive ? <RiArrowUpSLine /> : <RiArrowDownSLine />
                        }
                        expandIconPosition={["end"]}
                      >
                        <Panel
                          header={<a href="/">{fvrt.header}</a>}
                          key={fvrt.key}
                          // extra={genExtra(data.key)}
                          extra={
                            fvrt.favorite ? (
                              <StarFilled
                                onClick={() => handleFavorite(fvrt.key)}
                              />
                            ) : (
                              <StarOutlined
                                onClick={() => handleFavorite(fvrt.key)}
                              />
                            )
                          }
                          className="collapseInnerPanel"
                          collapsible="icon"
                        >
                          <p>{text}</p>
                        </Panel>
                      </Collapse>
                    </Col>
                  );
                })} */}
            </Row>
          </Panel>
        </Collapse>

        <br />

        <>
          {allReports.map((data, index) => {
            return (
              <>
                <Collapse
                  expandIcon={({ isActive }) =>
                    isActive ? <RiArrowUpSLine /> : <RiArrowDownSLine />
                  }
                  className="reportsPageCollapse"
                >
                  <Panel header={data.panelHeader} key={data.key}>
                    <Row gutter={[24, 16]} style={{ rowGap: "0" }}>
                      {data.children.map((d, index) => {
                        return (
                          <Col span={8} key={index}>
                            <Collapse
                              expandIcon={({ isActive }) =>
                                isActive ? (
                                  <RiArrowUpSLine />
                                ) : (
                                  <RiArrowDownSLine />
                                )
                              }
                              expandIconPosition={["end"]}
                            >
                              <Panel
                                header={<a href="/">{d.header}</a>}
                                key={d.key}
                                extra={
                                  d.favorite ? (
                                    <StarFilled
                                      onClick={() => handleFavorite(d.key)}
                                    />
                                  ) : (
                                    <StarOutlined
                                      onClick={() => handleFavorite(d.key)}
                                    />
                                  )
                                }
                                className="collapseInnerPanel"
                                collapsible="icon"
                              >
                                <p>{d.description}</p>
                              </Panel>
                            </Collapse>
                          </Col>
                        );
                      })}
                    </Row>
                  </Panel>
                </Collapse>
                <br />
              </>
            );
          })}
        </>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReportsRightBar} />
      </div>
    </>
  );
}

export default Reports;
